export default __webpack_public_path__ + "static/media/hogwartsmagic.587e6aa6.jpg";